import "./App.css";

const products = [
  { id: 1, name: "Product 1", price: "₹10,000", img: "/images/photo1.jpg" },
  { id: 2, name: "Product 2", price: "₹12,000", img: "/images/photo2.jpg" },
  { id: 3, name: "Product 3", price: "₹14,000", img: "/images/photo3.jpg" },
    { id: 4, name: "Product 4", price: "₹16,000", img: "/images/photo4.jpg" },

];

function App() {
  return (
    <div className="productgrid">
      {products.map((product) => (
        <div className="productcard" key={product.id}>
          <img src={product.img} alt={product.name} />
          <h3>{product.name}</h3>
          <p>{product.price}</p>
        </div>
      ))}
    </div>
  );
}

export default App;
